module.exports = __webpack_public_path__ + "assets/angular.41eaea26322786b81b064790d8b49fbd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/angular.png
 ** module id = 286
 ** module chunks = 0
 **/